import { getUniqueName } from '@/utils/getUniqueName';

import { NEW_TAB_NAME } from '../constants/const';

export const getUniqueTabName = (existingNames: string[]): string => {
  return getUniqueName(existingNames, NEW_TAB_NAME);
};

export default getUniqueTabName;
